import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, Kicker } from "@/components/Reveal";
import { serviceImages } from "@/data/content";
import BrandingFrame from "@/components/BrandingFrame";

const Services = () => {
  const { t } = useLanguage();
  const s = t.services;
  const imgs = [serviceImages[0], serviceImages[2], serviceImages[1], serviceImages[4]];

  return (
    <div data-testid="services-page" className="bg-cream">
      <section className="pt-40 md:pt-52 pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <Kicker>{s.kicker}</Kicker>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mt-6 items-end">
            <Reveal delay={0.1} className="md:col-span-8">
              <h1 className="font-serif font-light text-5xl sm:text-6xl md:text-7xl text-charcoal leading-[1.04]">
                {s.title}
              </h1>
            </Reveal>
            <Reveal delay={0.2} className="md:col-span-4">
              <p className="text-charcoal/70 font-light leading-relaxed">
                {s.intro}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Four ways — Build / Grow / Create / Connect */}
      <section className="pb-12 md:pb-20" data-testid="services-buckets">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-20 md:space-y-28">
          {s.buckets.map((b, i) => (
            <Reveal key={b.title} delay={0.05}>
              <div
                data-testid={`service-bucket-${i}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 items-center"
              >
                {/* Image */}
                <div
                  className={`md:col-span-6 ${
                    i % 2 === 1 ? "md:order-2" : ""
                  }`}
                >
                  <div className="overflow-hidden aspect-[4/3] bg-cream-2">
                    <img
                      src={imgs[i]}
                      alt={b.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                {/* Text */}
                <div className="md:col-span-5 md:col-start-8">
                  <span className="font-mono text-xs text-taupe">{b.n}</span>
                  <h2 className="font-serif font-light text-5xl md:text-6xl text-charcoal mt-3">
                    {b.title}
                  </h2>
                  <p className="text-charcoal/70 font-light leading-relaxed mt-5 max-w-md">
                    {b.desc}
                  </p>
                  <ul className="mt-7 flex flex-wrap gap-x-3 gap-y-2">
                    {b.items.map((it) => (
                      <li
                        key={it}
                        className="font-mono text-[0.7rem] uppercase tracking-[0.16em] text-olive border border-border-subtle px-4 py-2"
                      >
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <BrandingFrame />
    </div>
  );
};

export default Services;
